export const GridConfig = {
	grid: {
		gridId: 'FMVStatementBulkProcessingGrid',
		height: 500,
		checkbox: true,
		edit: false,
		delete: false,
		pageSize: 100,
		groupable: true,
		pdfdoc: true
	},
	columns: {
		Id: {
			class: "lookup",
			dataName: 'Id',
			type: 'number',
			title: 'Partner Id',
			width: 100,
			hidden: true,
			readOnly: false
		},
		TaxId: {
			class: "lookup",
			dataName: 'TaxId',
			type: 'string',
			title: 'Tax ID',
			width: 160,
			hidden: false,
			readOnly: true
		},
		// FullName: {
		// 	class: "lookup",
		// 	dataName: 'FullName',
		// 	type: 'string',
		// 	title: 'Partner Name',
		// 	width: 200,
		// 	hidden: false,
		// 	readOnly: true
		// },
		Status: {
			class: "value",
			dataName: 'Status',
			type: 'string',
			title: 'Status',
			width: 150,
			hidden: false,
			readOnly: true
		},
		DownloadLink: {
			class: "value",
			dataName: 'DownloadLink',
			type: 'string',
			title: 'DownloadLink',
			width: 150,
			hidden: true,
			readOnly: true
		}
	}
}

export const ToolBarConfig = {
	list: 'ToolBarItems',
	items: [{
			id: "btnGenerateErrorPDF",
			type: "button",
			text: "Run Error Items",
			showIcon: "toolbar",
			icon: "file-pdf",
			attributes: {
				"class": "float-right-btn btn btn-primary"
			},
		},
		{
			id: "btnDownload",
			type: "button",
			text: "Download Zip",
			showIcon: "toolbar",
			icon: "download",
			attributes: {
				"class": "float-right-btn btn btn-tertiary"
			},
		},

		// {
		// 		id:"btnGeneratePDF",
		// 		type: "button",
		// 		text: "Generate Report",
		// 		showIcon: "toolbar",
		// 		icon:"file-pdf",
		// 		attributes: { "class": "float-right-btn btn btn-primary" },					
		// }    

	]
}